import React, { useState } from "react";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import moment from "moment";
import OrderDescModelBody from "../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrdersTable/OrderDescModelBody";

const OrderViewModal = (props) => {
  const [cash, setCash] = useState("");
  const [cashError, setCashError] = useState(false);

  const [remaining, setRemaining] = useState(0);

  const handleCash = (e) => {
    if (
      /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/.test(parseFloat(e.target.value))
    ) {
      setCash(e.target.value);
      setCashError(false);
      setRemaining((props?.total - parseFloat(e.target.value)).toFixed(2));
    } else {
      setCashError(true);
    }
  };

  const updatedTime = moment(
    props?.orderDetails?.order_status === 0
      ? props?.orderDetails?.max_time_date || props?.orderDetails?.createdAt
      : props?.orderDetails?.max_time_date ||
          props?.orderDetails?.OrderAcceptTime
  ).add(
    props?.orderDetails?.order_status === 0
      ? // ||
        //   props?.orderDetails?.now === false
        parseInt(props?.orderDetails?.wait_time)
      : parseInt(props?.orderDetails?.max_time),
    "minutes"
  );
  // props.orderDetails?.max_time
  // const currentTimeTwo = new Date().getTime();
  // const updatedTimeNew = updatedTime.getTime();
  // const waitTime = parseInt(props.orderDetails.max_time) * 60 * 1000;
  // let updateWaitTime = updatedTimeNew + waitTime;
  // let diff = updateWaitTime - currentTimeTwo;
  let diff = updatedTime.diff(moment());

  const acceptTime =
    props?.orderDetails?.order_status === 0
      ? new Date(props?.orderDetails?.createdAt)
      : props?.orderDetails?.order_status === 8
      ? new Date(props?.orderDetails?.createdAt)
      : props?.orderDetails?.order_status === 7
      ? new Date(props?.orderDetails?.createdAt)
      : new Date(props?.orderDetails?.createdAt);
  // : new Date(props?.orderDetails?.OrderAcceptTime);

  const orderEndTime =
    props?.orderDetails?.order_status === 0
      ? new Date()
      : props?.orderDetails?.order_status === 8
      ? new Date(props?.orderDetails?.updatedAt)
      : props?.orderDetails?.order_status === 7
      ? new Date(props?.orderDetails?.OrderCompleteTime)
      : new Date();

  var endSeatedTime = moment(orderEndTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(acceptTime).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  const seated_time_difference = (minutesSeated) => {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  };

  return (
    <>
      <Modal show={true} onHide={props.handleClose} centered size={"xl"}>
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">View Order Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <OrderDescModelBody
            allData={props.orderDetails && props?.orderDetails}
            seated_time_difference={seated_time_difference(minutesSeated)}
            {...props}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OrderViewModal;
